import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  LoaderButtonComponent,
  TypedFormControl,
  TypedFormGroup,
} from '@principle-theorem/ng-shared';
import { MultiFactorResolver, TotpMultiFactorInfo } from 'firebase/auth';
import { AuthService } from '../../auth.service';
import { getAuthErrorMessage } from '../auth-error-messages';
import { MultifactorService } from '../multifactor.service';

interface IVerifyForm {
  code: string;
}

@Component({
  selector: 'pt-totp-verify',
  templateUrl: './totp-verify.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    LoaderButtonComponent,
  ],
})
export class TotpVerifyComponent {
  private _multifactorService = inject(MultifactorService);

  auth = inject(AuthService);
  resolver = input.required<MultiFactorResolver>();
  hint = input.required<TotpMultiFactorInfo>();
  verified = output<void>();
  isLoading = signal(false);
  errorMessage = '';

  codeForm = new TypedFormGroup<IVerifyForm>({
    code: new TypedFormControl<string>('', [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(6),
    ]),
  });

  async verify(): Promise<void> {
    if (!this.codeForm.valid) {
      return;
    }
    this.isLoading.set(true);
    this.errorMessage = '';
    try {
      await this._multifactorService.verifyWithTotp(
        this.resolver(),
        this.hint(),
        this.codeForm.value.code
      );
      this.verified.emit();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('MFA TOTP verify failed:', error);
      this.errorMessage = getAuthErrorMessage(error);
    } finally {
      this.isLoading.set(false);
    }
  }
}
